import { Subject } from "rxjs";

export class VolumeControlService {

  // The key / volume identifier
  protected volumeId = '';

  // Default and current volume
  protected defaultVolume = 10;
  protected volumeValue: number;

  // Simple store for volume
  volume$ = new Subject<number>;

  constructor(volumeId: string, defaultVolume?: number) {
    this.volumeId = 'volume-' + volumeId;
    if (!this.volumeId) {
      throw new Error('VolumeControlService must provide a volumeId!');
    }
    if (defaultVolume) {
      this.defaultVolume = defaultVolume;
    }
    this.volumeValue = this.getInitialVolume();
  }

  getLocalStorageValue() {
    const value = localStorage.getItem(this.volumeId)
    if (!value) {
      return null;
    }
    return Number.parseInt(value, 10);
  }

  setLocalStorageValue(value: number): void {
    localStorage.setItem(this.volumeId, value.toString());
  }

  // retrieve the current Stage volume e.g. from localStorage
  getInitialVolume(): number {
    const localValue = this.getLocalStorageValue();
    if (localValue) {
      return localValue;
    }
    return this.defaultVolume;
  }

  updateVolume(volume: number): void {
    this.volumeValue = volume;
    this.volume$.next(volume);
    this.setLocalStorageValue(volume);
  }

  getVolumeValue(): number {
    return this.volumeValue;
  }

}
